import { IntegrationType } from 'generated/graphql';

export const getLinkableIntegrationTypes = (
  integrationType: IntegrationType,
) => {
  switch (integrationType) {
    case IntegrationType.Feedback:
      return [IntegrationType.User, IntegrationType.Account];
    case IntegrationType.User:
      return [IntegrationType.Feedback, IntegrationType.Account];
    case IntegrationType.Account:
      return [IntegrationType.Feedback, IntegrationType.User];
    case IntegrationType.Cohorts:
      return []; // We are not allowing linking of cohorts yet
    default:
      return [];
  }
};
